import { FC } from 'react'
import { PlaceholderCell } from 'components/extend'
import { useOnMount } from 'hooks'
import { useLazyGetContactByIdQuery } from 'modules/contact/api'
import { getContactFullName } from 'modules/contact/helpers'

const ContactDetailTitle: FC<{ id?: string }> = ({ id }) => {
  const [getContactById, { data, isFetching }] = useLazyGetContactByIdQuery()

  useOnMount(() => {
    getContactById(id || '')
  })

  return (
    <span data-test-id="contacts-page--contact-detail--full-name">
      {isFetching ? <PlaceholderCell height={32} /> : data && getContactFullName(data)}
    </span>
  )
}

export default ContactDetailTitle
